import StepsIndicator from '../steps-indicator'
import { Input } from '../ui'
import { Alert, AlertDescription } from '../ui/alert'
import { Button } from '../ui/button'
import { Card } from '../ui/card'

interface SetupPasswordProps {
  setPassword: (password: string) => void
  setConfirmPassword: (confirmPassword: string) => void
  handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  isLoading?: boolean
  formError?: string
}

export function SetupPassword({
  setPassword,
  setConfirmPassword,
  handleSubmit,
  isLoading,
  formError,
}: SetupPasswordProps) {
  return (
    <Card className="w-full max-w-lg border border-white rounded-3xl bg-white/50 p-8">
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col w-full gap-8">
          <div className="flex flex-col items-center mx-8 gap-2">
            <h1 className="font-semibold text-lavender-900 text-[40px] leading-[52px]">Setup Password</h1>
            <p className="font-[400] text-[18px] leading-[32px] text-[#666666]">
              Create password to activate your account
            </p>
          </div>
          <StepsIndicator currentStep={1} />
          <div className="flex flex-col gap-4 mt-8">
            <div className="flex flex-col gap-2">
              <p className="text-sm text-lavender-900">Password *</p>
              <Input
                className="rounded-3xl"
                placeholder="Enter Your Password"
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
                data-testid="password-input"
                type="password"
              />
              <p className="text-gray-600 text-xs">Must contain atleast 8 characters</p>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-lavender-900">Confirm Password *</p>
              <Input
                className="rounded-3xl"
                placeholder="Re-enter Your Password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={isLoading}
                type="password"
                data-testid="confirm-password-input"
              />
              <p className="text-gray-600 text-xs">Both passwords must match</p>
            </div>
          </div>
          {formError && (
            <Alert variant="destructive" className="mt-4">
              <AlertDescription>{formError}</AlertDescription>
            </Alert>
          )}
          <Button type="submit" disabled={isLoading} className="rounded-3xl bg-[#354297] hover:bg-[#354297]">
            {isLoading ? 'Setting Password...' : 'Set Password'}
          </Button>
        </div>
      </form>
    </Card>
  )
}
